import React, { memo, useMemo } from "react";
import { SkeletonLine } from "Components/Skeletion";
import AdvancedLink from "Components/AdvancedLink";
import "./styles.scss";

const Breadcrumb = ({ type, key: componentKey, loading = false, data = [] }) => {
  const homeBreadcrumb = {
    categoryName: "home",
    urlKey: "/",
    catId: "",
  };

  const updatedData = useMemo(() => [homeBreadcrumb, ...data], [data]);

  const dataBlock = useMemo(() => (
    updatedData.map((elem, ind) => (
      <div className="item flex middle gap-1 border_sm" key={`Breadcrumb__${componentKey}${ind}`}>
        <div className="divider lg-hide-divider">{`<`}</div>
        <AdvancedLink
          className="link fs-14 lg-fs-13"
          to={elem?.urlKey}
          aria-label={elem?.categoryName}
          state={{
            categoryData: {
              catId: elem?.catId,
              catUrl: elem?.url_key,
            },
            urlType: elem?.urlType,
            currentPageView: elem?.plp_design_view
          }}
        >
          {elem?.categoryName}
        </AdvancedLink>
        {ind !== updatedData.length - 1 && (
          <div className="divider hide-on-mobile">{`>`}</div>
        )}
      </div>
    ))
  ), [updatedData, componentKey]);

  const skeletonBlock = (
    <div className="breadcrumbs__block flex gap-5 wrap">
      {[...Array(2)].map((_, ind) => (
        <div className="item flex middle gap-1" key={`skeleton__${type}${ind}`}>
          <SkeletonLine width="100px" height="21px" />
        </div>
      ))}
    </div>
  );

  return (
    <div className="breadcrumbs__container container px-4 pb-4">
      <div className="breadcrumbs__wrapper">
        {loading && !data.length ? skeletonBlock : (
          <div className="breadcrumbs__block flex middle gap-1"
            role="navigation"
            aria-label="Breadcrumb"
          >
            {dataBlock}
          </div>
        )}
      </div>
    </div>
  );
};

export default memo(Breadcrumb);
